const ACTIONS_REPORT_DEFINITION = {
  INVALIDATE: 'REPORT_DEFINITIONS_INVALIDATE',
  RECEIVE: 'REPORT_DEFINITIONS_RECEIVE',
  DELETE: 'REPORT_DEFINITION_DELETE',
  UPDATE: 'REPORT_DEFINITION_UPDATE',
};

export default ACTIONS_REPORT_DEFINITION;
